export default {
	"c3e9fc606eca1c9128640e2195cb847e": "已有簽約訂單",
	"13ad634c1fdc07c7608baccb98aac1f9": "您已簽約先學後付訂單，請前往訂單詳情，查看詳細內容。",
	"e4bf091c606d1454ac658f0488399f77": "前往訂單詳情查看"
}
